const formatISK = price => price ? price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : null;

export {
    formatISK
}